import React, { useEffect, useState } from "react";
import api from "../../store/services/api";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { LightDarkGreyBox } from "../styled";
import { IconStackButtonFullHeight } from "../styled/button";

export default function CheckShippingModal(props) {
  const [loading, setLoading] = useState(true);

  const [restaurants, setRestaurants] = useState([]);

  async function getRestaurants() {
    const res = await api.get("/merchant");
    setRestaurants(res.data);
    setLoading(false);
  }

  const _handleModal = () => {
    props.handleModal({});
  };

  async function prepareCheckRide(ifood_id) {
    _handleModal();
    await props.checkRide(ifood_id);
  }

  useEffect(() => {
    getRestaurants();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "none",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    "&:focus-visible": {
      border: "none",
    },
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.show}
      onClose={_handleModal}
      closeAfterTransition
      sx={{ zIndex: 999999 }}
    >
      <Fade in={props.show}>
        <Box sx={style}>
          {loading === false ? (
            <Box sx={{ flexGrow: 1 }}>
              <LightDarkGreyBox sx={{ mb: 2 }}>
                <Typography
                  id="transition-modal-title"
                  variant="h5"
                  component="h5"
                >
                  Selecione o Restaurante pelo qual deseja solicitar o
                  entregador iFood
                </Typography>
              </LightDarkGreyBox>
              <Grid container spacing={2}>
                {restaurants.map((restaurant) => {
                  if (restaurant.ifood_id)
                    return (
                      <Grid item xs={12} sm={4} md={3}>
                        <IconStackButtonFullHeight
                          padding={60}
                          onClick={() => prepareCheckRide(restaurant.ifood_id)}
                        >
                          <Card
                            variant="outlined"
                            sx={{
                              padding: 4,
                              backgroundColor: "#fbfbfb",
                              "&:hover": {
                                backgroundColor: "#f2f2f2",
                                cursor: "pointer",
                              },
                            }}
                          >
                            <Typography variant="body1" fontWeight={700}>
                              {restaurant.name}
                            </Typography>
                          </Card>
                        </IconStackButtonFullHeight>
                      </Grid>
                    );
                })}
              </Grid>
            </Box>
          ) : (
            <Box sx={{ display: "flex" }}>
              <CircularProgress
                sx={{ margin: "auto", "&:focus-visible": { border: "none" } }}
              />
            </Box>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
